<div #topDiv class="content" role="main">
    <div class="subtoolbar">
        <div class="subtoolbar__fonts" matTooltipClass="tooltip" matTooltip="Text Font">
            <select id="fontText" name="fontText" [(ngModel)]="selectedSymbolFont" [value]="selectedSymbolFont"
                (change)="UpdateRecord()" [disabled]="isNameDisabled">
                <option value="Georgia,serif" style="font-family: Georgia,serif">Georgia</option>
                <option value="Palatino Linotype,Book Antiqua,Palatino,serif"
                    style="font-family: Palatino Linotype,Book Antiqua,Palatino,serif">Palatino Linotype</option>
                <option value="Times New Roman,Times,serif" style="font-family: Times New Roman,Times,serif">Times New
                    Roman</option>
                <option value="Arial,Helvetica,sans-serif" style="font-family: Arial,Helvetica,sans-serif">Arial
                </option>
                <option value="Arial Black,Gadget,sans-serif" style="font-family: Arial Black,Gadget,sans-serif">Arial
                    Black</option>
                <option value="Comic Sans MS,cursive,sans-serif" style="font-family: Comic Sans MS,cursive,sans-serif">
                    Comic Sans MS</option>
                <option value="Impact,Charcoal,sans-serif" style="font-family: Impact,Charcoal,sans-serif">Impact
                </option>
                <option value="Lucida Sans Unicode,Lucida Grande,sans-serif"
                    style="font-family: Lucida Sans Unicode,Lucida Grande,sans-serif">Lucida Sans Unicode</option>
                <option value="Tahoma,Geneva,sans-serif" style="font-family: Tahoma,Geneva,sans-serif">Tahoma</option>
                <option value="Trebuchet MS,Helvetica,sans-serif"
                    style="font-family: Trebuchet MS,Helvetica,sans-serif">Trebuchet MS</option>
                <option value="Verdana,Geneva,sans-serif" style="font-family: Verdana,Geneva,sans-serif">Verdana
                </option>
                <option value="Courier New,Courier,monospace" style="font-family: Courier New,Courier,monospace">Courier
                    New</option>
                <option value="Lucida Console,Monaco,monospace" style="font-family: Lucida Console,Monaco,monospace">
                    Lucida Console</option>
            </select>
        </div>
        <div class="subtoolbar__fonts" matTooltipClass="tooltip" matTooltip="Text Size">
            <select id="fontSize" name="fontSize" [(ngModel)]="selectedSymbolFontSize" [value]="selectedSymbolFontSize"
                (change)="UpdateRecord()" [disabled]="isNameDisabled">
                <option value="1px">1</option>
                <option value="2px">2</option>
                <option value="3px">3</option>
                <option value="4px">4</option>
                <option value="5px">5</option>
                <option value="6px">6</option>
                <option value="7px">7</option>
                <option value="8px">8</option>
                <option value="9px">9</option>
                <option value="10px">10</option>
                <option value="11px">11</option>
                <option value="12px">12</option>
                <option value="13px">13</option>
                <option value="14px">14</option>
                <option value="15px">15</option>
                <option value="16px">16</option>
                <option value="17px">17</option>
                <option value="18px">18</option>
                <option value="19px">19</option>
                <option value="20px">20</option>
            </select>
        </div>
        <div class="subtoolbar__toolText" matTooltipClass="tooltip" matTooltip="Symbol Text">
            <input name="name" [(ngModel)]="selectedSymbol.name" type="text" matInput placeholder="Name"
                (input)="UpdateRecord()" [disabled]="isNameDisabled" required>
        </div>
        <div class="subtoolbar__textColor mr_15" matTooltipClass="tooltip" matTooltip="Text Color">
            <input name="textcolor" [(ngModel)]="selectedtextColor" type="color" matInput placeholder="Text Color"
                (input)="UpdateRecord()" [disabled]="isNameDisabled" required>
        </div>
        <div class="subtoolbar__textColor mr_15" matTooltipClass="tooltip" matTooltip="BG Color">
            <input name="color" [(ngModel)]="selectedSymbolColor" type="color" matInput placeholder="BG Color"
                (input)="UpdateRecord()" [disabled]="isColorDisabled" required>
        </div>
        <div class="subtoolbar__strokeColor mr_15" matTooltipClass="tooltip" matTooltip="Stroke Color">
            <input name="bordercolor" [(ngModel)]="selectedSymbolStrokeColor" type="color" matInput
                (input)="UpdateRecord()" placeholder="border color" [disabled]="isDisabled" required>
        </div>
        <div class="subtoolbar__strokeWidth mr_15" matTooltipClass="tooltip" matTooltip="Stroke Width">
            <select id="lineDash" name="lineDash" [(ngModel)]="selectedStrokeWidth" [value]="selectedStrokeWidth"
                (change)="UpdateRecord()" style="min-width: 50px;" [disabled]="isDisabled" (change)="UpdateRecord()">
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
            </select>
        </div>
        <div class="subtoolbar__strokeDash mr_15" matTooltipClass="tooltip" matTooltip="Stroke Style">
            <select id="lineDash" name="lineDash" [(ngModel)]="selectedStrokeDash" style="min-width: 50px;"
                (change)="UpdateRecord()" [disabled]="isDisabled">
                <option value="0">0</option>
                <option value="3,3">3</option>
                <option value="5,5">5</option>
                <option value="7,7">7</option>
                <option value="10,10">10</option>
                <option value="13,13">13</option>
                <option value="15,15">15</option>
                <option value="17,17">17</option>
                <option value="20,20">20</option>
            </select>
        </div>
        <select id="lineDash" name="lineDash" [(ngModel)]="currentWF" style="max-width: 250px;"
            class="subtoolbar__trash" (change)="reloadWF()" matTooltipClass="tooltip"
            matTooltip="Reload Existing Workflow">
            <option *ngFor="let svgData of svgDataList" attr.value="{{svgData.name}}">{{svgData.name}}</option>
        </select>
        <button mat-icon-button color="primary" matTooltipClass="tooltip" matTooltip="Add New SVG"
            (click)="AddNewSVG()">
            <mat-icon>add_circle</mat-icon>
        </button>
        <button mat-icon-button color="warn" matTooltipClass="tooltip" matTooltip="Delete" (click)="DeleteRecord()">
            <mat-icon>delete</mat-icon>
        </button>
        <input name="svgName" [(ngModel)]="svgName" type="text" matInput style="max-width:150px;"
            matTooltipClass="tooltip" matTooltip="SVG Name" placeholder="SVG Name" required>
        <button mat-icon-button style="color:green" matTooltipClass="tooltip" matTooltip="Save SVG" (click)="saveSVG()">
            <mat-icon>save</mat-icon>
        </button>
    </div>
    <div class="mainWrapper">
        <div class="tool_holder">
            <div draggable="true" element="start">
                <svg width="50" height="50" matTooltipClass="tooltip" matTooltip="Start">
                    <rect width="35" height="35" x="10" y="10" rx="25"
                        attr.fill="{{isSymbolSelected && selectedSymbolType=='start'?'#eeeeee':'#ffffff'}}"
                        style="stroke-width:1;stroke:rgb(0,0,0)" class="startmaster" />
                </svg>
            </div>
            <div draggable="true" element="startcircle">
                <svg width="50" height="50" matTooltipClass="tooltip" matTooltip="Start circle">
                    <rect width="35" height="35" x="10" y="10" rx="25" style="stroke-width:3;stroke:rgb(0,0,0)"
                        attr.fill="{{isSymbolSelected && selectedSymbolType=='startcircle'?'#eeeeee':'#ffffff'}}"
                        class="startcirclemaster" />
                </svg>
            </div>
            <div draggable="true" element="intermidiateprocess">
                <svg width="50" height="50" matTooltipClass="tooltip" matTooltip="Intermidiate Process">
                    <rect width="35" height="35" x="10" y="10" rx="25" style="stroke-width:2;stroke:rgb(0,0,0)"
                        attr.fill="{{isSymbolSelected && selectedSymbolType=='intermidiateprocess'?'#eeeeee':'#ffffff'}}"
                        class="intermidiateprocessmaster" />
                    <rect width="27" height="27" x="14" y="14" rx="20" style="stroke-width:2;stroke:rgb(0,0,0)"
                        attr.fill="{{isSymbolSelected && selectedSymbolType=='intermidiateprocess'?'#eeeeee':'#ffffff'}}"
                        class="intermidiateprocessmaster" />
                </svg>
            </div>
            <div draggable="true" element="process">
                <svg width="50" height="50" matTooltipClass="tooltip" matTooltip="Process">
                    <rect width="42" height="26" x="4" y="10" style="stroke-width:1;stroke:rgb(0,0,0)"
                        attr.fill="{{isSymbolSelected && selectedSymbolType=='process'?'#eeeeee':'#ffffff'}}"
                        class="processmaster" />
                </svg>
            </div>
            <div draggable="true" element="rectsubprocess">
                <svg width="50" height="50" matTooltipClass="tooltip" matTooltip="Sub Process">
                    <rect width="42" height="26" x="4" y="10"
                        style="stroke-width:1;stroke:rgb(0,0,0);stroke-dasharray: 5,5;"
                        attr.fill="{{isSymbolSelected && selectedSymbolType=='rectsubprocess'?'#eeeeee':'#ffffff'}}"
                        class="rectsubprocessmaster" />
                </svg>
            </div>
            <div draggable="true" element="rectcall">
                <svg width="50" height="50" matTooltipClass="tooltip" matTooltip="Call">
                    <rect width="42" height="26" x="4" y="10" style="stroke-width:3;stroke:rgb(0,0,0)"
                        attr.fill="{{isSymbolSelected && selectedSymbolType=='rectcall'?'#eeeeee':'#ffffff'}}"
                        class="rectcallmaster" />
                </svg>
            </div>
            <div draggable="true" element="recttransaction">
                <svg width="50" height="50" matTooltipClass="tooltip" matTooltip="Transaction">
                    <rect width="42" height="26" x="4" y="10" rx="5" style="stroke-width:1;stroke:rgb(0,0,0)"
                        attr.fill="{{isSymbolSelected && selectedSymbolType=='recttransaction'?'#eeeeee':'#ffffff'}}"
                        class="recttransactionmaster" />
                    <rect width="34" height="18" x="8" y="14" rx="5" style="stroke-width:1;stroke:rgb(0,0,0)"
                        attr.fill="{{isSymbolSelected && selectedSymbolType=='recttransaction'?'#eeeeee':'#ffffff'}}"
                        class="recttransactionmaster" />
                </svg>
            </div>
            <div draggable="true" element="decision">
                <svg width="60" height="40" matTooltipClass="tooltip" matTooltip="decision">
                    <rect width="23" height="23" x="18" y="8" transform="rotate(45)" class="decision decisionmaster"
                        style="stroke-width:1;stroke:rgb(0,0,0)"
                        attr.fill="{{isSymbolSelected && selectedSymbolType=='decision'?'#eeeeee':'#ffffff'}}" />
                </svg>
            </div>
            <div draggable="true" element="poolline">
                <svg width="50" height="40" matTooltipClass="tooltip" matTooltip="poolline">
                    <defs>
                        <pattern attr.id="{{nodeToolIcon.id}}" x="0%" y="0%" height="100%" width="100%"
                            viewBox="0 0 512 512">
                            <image x="0%" y="0%" width="512" height="512" attr.xlink:href="{{nodeToolIcon.imgPath}}">
                            </image>
                        </pattern>
                    </defs>
                    <rect attr.y="{{ 6 }}" attr.x="{{ 10 }}" attr.width="{{ 30}}" attr.height="{{ 30 }}" rx="0"
                        attr.fill="{{ nodeToolIcon.fillImg }}" />
                </svg>
            </div>
            <div draggable="true" element="arrow">
                <svg width="50" height="40" matTooltipClass="tooltip" matTooltip="Arrow">
                    <defs>
                        <pattern attr.id="{{arrowToolIcon.id}}" x="0%" y="0%" height="100%" width="100%"
                            viewBox="0 0 512 512">
                            <image x="0%" y="0%" width="512" height="512" attr.xlink:href="{{arrowToolIcon.imgPath}}">
                            </image>
                        </pattern>
                    </defs>
                    <rect attr.y="{{ 6 }}" attr.x="{{ 10 }}" attr.width="{{ 30}}" attr.height="{{ 30 }}" rx="0"
                        attr.fill="{{ arrowToolIcon.fillImg }}" />
                </svg>
            </div>
            <div draggable="true" element="freetext">
                <svg width="50" height="40" matTooltipClass="tooltip" matTooltip="Free Text">
                    <defs>
                        <pattern attr.id="{{freeTextImg.id}}" x="0%" y="0%" height="100%" width="100%"
                            viewBox="0 0 512 512">
                            <image x="0%" y="0%" width="512" height="512" attr.xlink:href="{{freeTextImg.imgPath}}">
                            </image>
                        </pattern>
                    </defs>
                    <rect attr.y="{{ 6 }}" attr.x="{{ 10 }}" attr.width="{{ 30}}" attr.height="{{ 30 }}" rx="0"
                        attr.fill="{{ freeTextImg.fillImg }}" />
                </svg>
            </div>
            <div draggable="true" element="pool">
                <svg width="60" height="40" matTooltipClass="tooltip" matTooltip="pool">
                    <rect width="40" height="25" x="10" y="8" style="stroke-width:1;stroke:rgb(0,0,0)"
                        class="poolmaster"
                        attr.fill="{{isSymbolSelected && selectedSymbolType=='pool'?'#eeeeee':'#ffffff'}}" />
                    <rect width="10" height="10" x="40" y="23" style="stroke-width:1;stroke:rgb(0,0,0)"
                        class="poolmaster"
                        attr.fill="{{isSymbolSelected && selectedSymbolType=='pool'?'#eeeeee':'#ffffff'}}" />
                </svg>
            </div>
            <div draggable="true" *ngFor="let ei of eventImg;let i = index" element="event"
                attr.eifillImg="{{ei.fillImg}}" attr.eiid="{{ei.id}}" attr.eiimgPath="{{ei.imgPath}}">
                <svg width="70" height="70" matTooltipClass="tooltip" matTooltip="Event">
                    <defs>
                        <pattern attr.id="{{ei.id}}" x="0%" y="0%" height="100%" width="100%" viewBox="0 0 512 512">
                            <image x="0%" y="0%" width="512" height="512" attr.xlink:href="{{ei.imgPath}}">
                            </image>
                        </pattern>
                    </defs>
                    <rect attr.y="{{0}}" attr.x="{{0}}" attr.width="{{60}}" attr.height="{{70}}" rx="0"
                        attr.fill="{{ ei.fillImg }}" />
                </svg>
            </div>
        </div>
        <div class="flowWrapper">
            <div class="flowHolder">
                <svg id="mainSVG" attr.width="{{screenWidth}}" attr.height="{{screenHeight}}"
                    onload="makeDraggable(evt)" (click)="createSelectedSymbol($event)" (mousemove)="mymousemove($event)"
                    (mouseup)="svgMouseUp()">
                    <defs>
                        <marker id="arrow" viewBox="0 -5 10 10" refX="10" refY="0" markerWidth="3" markerHeight="5"
                            orient="auto">
                            <path d="M0,-5L10,0L0,5" class="arrowHead"></path>
                        </marker>
                    </defs>
                    <style>
                        .background {
                            fill: #eee;
                        }

                        .static {
                            cursor: not-allowed;
                        }

                        .draggable {
                            cursor: move;
                        }
                    </style>
                    <script type="text/javascript">
                        function makeDraggable(evt) {
                            var svg = evt.target;
                            svg.addEventListener('mousedown', startDrag);
                            svg.addEventListener('mousemove', drag);
                            svg.addEventListener('mouseup', endDrag);

                            function getMousePosition(evt) {
                                var CTM = svg.getScreenCTM();
                                return {
                                    x: (evt.clientX - CTM.e) / CTM.a,
                                    y: (evt.clientY - CTM.f) / CTM.d
                                };
                            }

                            var selectedElement, offset;
                            function startDrag(evt) {
                                if (evt.target.classList.contains('draggable')) {
                                    selectedElement = evt.target;

                                    offset = getMousePosition(evt);
                                    offset.x -= parseFloat(selectedElement.getAttributeNS(null, "x"));
                                    offset.y -= parseFloat(selectedElement.getAttributeNS(null, "y"));
                                }
                            }

                            function drag(evt) {
                                if (selectedElement) {
                                    var coord = getMousePosition(evt);
                                    selectedElement.setAttributeNS(null, "x", coord.x - offset.x);
                                    selectedElement.setAttributeNS(null, "y", coord.y - offset.y);
                                }
                            }

                            function endDrag(evt) {
                                selectedElement = null;
                            }
                        }
                    </script>

                    <!-- pool start -->
                    <rect *ngFor="let node of poolNodes" (mousedown)="mouseDown($event,node.nodeId,node.className)"
                        (mouseup)="mouseUp($event,node.nodeId,node.className)" attr.y="{{ node.nodeY }}"
                        (click)="symbolClick(node)" attr.x="{{ node.nodeX }}" attr.width="{{ node.width}}"
                        attr.height="{{ node.height }}" attr.style="{{ node.style }}"
                        attr.class="{{node.className+ ' draggable seffect'}}" rx="5" />

                    <rect *ngFor="let node of poolNodes" (mousedown)="mouseDown($event,node.nodeId,node.className,true)"
                        (mouseup)="mouseUp($event,node.nodeId,node.className,true)"
                        attr.y="{{ node.nodeY+node.height-20 }}" attr.x="{{ node.nodeX+node.width-20 }}"
                        attr.width="{{ 20 }}" attr.height="{{ 20 }}"
                        style="fill:#273746;stroke-width: 1; stroke: #34495E;"
                        attr.class="{{node.className + 'HS draggable'}}" />
                    <!-- pool end -->

                    <!--  poolline  Start -->
                    <line *ngFor="let poolLine of poolLineNodes" attr.y1="{{ poolLine.lineCordinates.y1 }}"
                        attr.x1="{{ poolLine.lineCordinates.x1  }}" attr.y2="{{ poolLine.lineCordinates.y2 }}"
                        attr.x2="{{ poolLine.lineCordinates.x2 }}" attr.style="{{ poolLine.style }}"
                        class="pointerCursor draggable" (click)="symbolClick(poolLine)"
                        (mousedown)="poolLinemouseDown($event,poolLine)" (mouseup)="poolLinemouseUp()" />
                    <rect *ngFor="let poolLine of poolLineNodes"
                        (mousedown)="mouseDown($event,poolLine.nodeId,poolLine.className,true,true)"
                        (mouseup)="mouseUp($event,poolLine.nodeId,poolLine.className,true,true)"
                        attr.y="{{ poolLine.lineCordinates.y1-picketWidth/2 }}"
                        attr.x="{{ poolLine.lineCordinates.x1-picketWidth/2}}" attr.width="{{ picketWidth }}"
                        attr.height="{{ picketWidth }}" rx="100" attr.style="{{poolLine.pickerStyle}}"
                        attr.class="{{poolLine.className + 'HS draggable pointerCursor'}}" />
                    <rect *ngFor="let poolLine of poolLineNodes"
                        (mousedown)="mouseDown($event,poolLine.nodeId,poolLine.className,true,false)"
                        (mouseup)="mouseUp($event,poolLine.nodeId,poolLine.className,true)"
                        attr.y="{{ poolLine.lineCordinates.y2-picketWidth/2 }}"
                        attr.x="{{ poolLine.lineCordinates.x2 -picketWidth/2}}" attr.width="{{ picketWidth }}"
                        attr.height="{{ picketWidth }}" rx="100" attr.style="{{poolLine.pickerStyle}}"
                        attr.class="{{poolLine.className + 'HS draggable pointerCursor'}}" />
                    <!-- poolline end -->

                    <!-- line to arrow -->
                    <line *ngFor="let linetoarrow of linetoarrowList" attr.y1="{{ linetoarrow.lineCordinates.y1 }}"
                        attr.x1="{{ linetoarrow.lineCordinates.x1  }}" attr.y2="{{ linetoarrow.lineCordinates.y2 }}"
                        attr.x2="{{ linetoarrow.lineCordinates.x2 }}" attr.style="{{ linetoarrow.style }}"
                        attr.class="{{linetoarrow.className}}" marker-end="url(#arrow)"
                        (click)="symbolClick(linetoarrow)" />
                    <rect *ngFor="let linetoarrow of linetoarrowList"
                        (mousedown)="newArrowMouseDown($event,linetoarrow,'S')"
                        (mouseup)="newArrowMouseUp($event,linetoarrow)"
                        attr.y="{{ linetoarrow.lineCordinates.y1-picketWidth/2 }}"
                        attr.x="{{ linetoarrow.lineCordinates.x1 -picketWidth/2}}" attr.width="{{ picketWidth }}"
                        attr.height="{{ picketWidth}}" rx="100" style="fill:#0bc928;stroke-width: 1; stroke: #34495E;"
                        attr.class="{{linetoarrow.className + 'HS draggable'}}" />
                    <rect *ngFor="let linetoarrow of linetoarrowList"
                        (mousedown)="newArrowMouseDown($event,linetoarrow,'E')"
                        (mouseup)="newArrowMouseUp($event,linetoarrow)"
                        attr.y="{{ linetoarrow.lineCordinates.y2-picketWidth/2 }}"
                        attr.x="{{ linetoarrow.lineCordinates.x2 -picketWidth/2}}" attr.width="{{ picketWidth}}"
                        attr.height="{{ picketWidth }}" rx="100" style="fill:#0bc928;stroke-width: 1; stroke: #34495E;"
                        attr.class="{{linetoarrow.className + 'HS draggable'}}" />
                    <!-- line to arrow -->

                    <!-- arrows start -->
                    <path *ngFor="let arrow of arrows" attr.y1="{{ arrow.y1 }}" attr.x1="{{ arrow.x1  }}"
                        attr.y2="{{ arrow.y2 }}" attr.x2="{{ arrow.x2 }}" attr.style="{{ arrow.lineStyle }}"
                        marker-end="url(#arrow)" attr.class="{{arrow.className+' pointerCursor'}}"
                        (click)="symbolClick(arrow)" attr.d="{{arrow.dValue}}" />
                    <rect *ngFor="let arrow of arrows" attr.y="{{ arrow.midY }}" attr.x="{{ arrow.midX }}"
                        attr.width="{{ picketWidth }}" attr.height="{{ picketWidth }}"
                        attr.style="{{arrow.pickerStyle}}" rx="50" (mouseup)="arrowCurveUp($event,arrow)"
                        (mousedown)="arrowCurveDown($event,arrow)"
                        attr.class="{{arrow.className + 'HS pointerCursor draggable'}}" />
                    <rect *ngFor="let arrow of arrows" (mousedown)="arrowMouseDown($event,arrow,'E')"
                        attr.y="{{ arrow.dragPointY1 }}" attr.x="{{ arrow.dragPointX1 }}" attr.width="{{ picketWidth }}"
                        attr.height="{{ picketWidth }}" attr.style="{{arrow.pickerStyle}}" rx="50"
                        attr.class="{{arrow.className + 'HS pointerCursor'}}" />
                    <rect *ngFor="let arrow of arrows" (mousedown)="arrowMouseDown($event,arrow,'S')"
                        attr.y="{{ arrow.dragPointY2 }}" attr.x="{{ arrow.dragPointX2 }}" attr.width="{{ picketWidth }}"
                        attr.height="{{ picketWidth }}" attr.style="{{arrow.pickerStyle}}" rx="50"
                        attr.class="{{arrow.className + 'HS pointerCursor'}}" />
                    <!-- arrows end -->

                    <!-- StartEnd start -->
                    <rect *ngFor="let node of startEndNodes" (mousedown)="mouseDown($event,node.nodeId,node.className)"
                        (mouseup)="mouseUp($event,node.nodeId,node.className)" rx="50" attr.y="{{ node.nodeY }}"
                        attr.x="{{ node.nodeX }}" attr.width="{{ nodeWidth }}" attr.height="{{ nodeHeight }}"
                        attr.style="{{ node.style }}" attr.class="{{node.className+ ' draggable seffect'}}"
                        (click)="symbolClick(node)" />
                    <text *ngFor="let node of startEndNodes" attr.y="{{ node.nodeY + 25 }}"
                        attr.x="{{ node.nodeX + 20 }}" fill="#34495E" attr.font-size="{{ fontSize }}"
                        attr.class="{{node.className+'HS prevent-select'}}" attr.style="{{node.fontStyle}}">
                        {{ node.name }}
                    </text>
                    <!-- StartEnd end -->

                    <!-- process start -->
                    <rect *ngFor="let node of processNodes" (mousedown)="mouseDown($event,node.nodeId,node.className)"
                        (mouseup)="mouseUp($event,node.nodeId,node.className)" attr.y="{{ node.nodeY }}"
                        attr.x="{{ node.nodeX }}" attr.width="{{ nodeWidth }}" attr.height="{{ nodeHeight }}"
                        attr.style="{{ node.style }}" attr.class="{{node.className+ ' draggable seffect'}}"
                        (click)="symbolClick(node)" />
                    <text *ngFor="let node of processNodes" attr.y="{{ node.nodeY + 25 }}"
                        attr.x="{{ node.nodeX + 10 }}" fill="#34495E" attr.font-size="{{ fontSize }}"
                        attr.class="{{node.className+'HS prevent-select'}}" attr.style="{{node.fontStyle}}">
                        {{ node.name }}
                    </text>
                    <!-- process end-->

                    <!-- decision start -->
                    <rect *ngFor="let node of decisionNodes" (mousedown)="mouseDown($event,node.nodeId,node.className)"
                        (mouseup)="mouseUp($event,node.nodeId,node.className)" attr.y="{{ node.nodeY }}"
                        attr.x="{{ node.nodeX }}" attr.width="{{ decisionWidth }}" attr.height="{{ decisionWidth }}"
                        attr.style="{{ node.style }}" attr.class="{{node.className+ ' decision draggable seffect'}}"
                        transform="rotate(45)" (click)="symbolClick(node)" />
                    <text *ngFor="let node of decisionNodes" attr.y="{{ node.nodeY + 40 }}"
                        attr.x="{{ node.nodeX  + 15}}" fill="#34495E" attr.font-size="{{ fontSize }}"
                        attr.class="{{node.className+'HS prevent-select'}}" attr.style="{{node.fontStyle}}">
                        {{ node.name }}
                    </text>
                    <!-- decision end -->

                    <!-- circle start -->
                    <rect *ngFor="let node of startCircleNodes"
                        (mousedown)="mouseDown($event,node.nodeId,node.className)"
                        (mouseup)="mouseUp($event,node.nodeId,node.className)" attr.y="{{ node.nodeY }}"
                        attr.x="{{ node.nodeX }}" attr.width="{{ circleWidth }}" attr.height="{{ circleWidth }}"
                        attr.style="{{ node.style }}" attr.class="{{node.className+ ' draggable seffect'}}" rx="100"
                        (click)="symbolClick(node)" />
                    <text *ngFor="let node of startCircleNodes" attr.y="{{ node.nodeY + 60 }}"
                        attr.x="{{ node.nodeX  + 15}}" fill="#34495E" attr.font-size="{{ fontSize }}"
                        attr.class="{{node.className+'HS prevent-select'}}" attr.style="{{node.fontStyle}}">
                        {{ node.name }}
                    </text>
                    <!-- circle end -->

                    <!-- intermediate circle start -->
                    <rect *ngFor="let node of intermediateCircleNodes"
                        (mousedown)="mouseDown($event,node.nodeId,node.className)"
                        (mouseup)="mouseUp($event,node.nodeId,node.className)" attr.y="{{ node.nodeY }}"
                        attr.x="{{ node.nodeX }}" attr.width="{{ circleWidth }}" attr.height="{{ circleWidth }}"
                        attr.style="{{ node.style }}" attr.class="{{node.className+ 'HS seffect'}}" rx="100"
                        (click)="symbolClick(node)" />
                    <rect *ngFor="let node of intermediateCircleNodes"
                        (mousedown)="mouseDown($event,node.nodeId,node.className)"
                        (mouseup)="mouseUp($event,node.nodeId,node.className)" attr.y="{{ node.nodeY+5 }}"
                        attr.x="{{ node.nodeX+5 }}" attr.width="{{ circleWidth-10 }}" attr.height="{{ circleWidth-10 }}"
                        attr.style="{{ node.style }}" attr.class="{{node.className+ ' draggable seffect'}}" rx="100"
                        (click)="symbolClick(node)" />
                    <text *ngFor="let node of intermediateCircleNodes" attr.y="{{ node.nodeY + 60 }}"
                        attr.x="{{ node.nodeX  + 15}}" fill="#34495E" attr.font-size="{{ fontSize }}"
                        attr.class="{{node.className+'HS prevent-select'}}" attr.style="{{node.fontStyle}}">
                        {{ node.name }}
                    </text>
                    <!-- intermediate circle end -->

                    <!-- end circle start -->
                    <rect *ngFor="let node of endCircleNodes" (mousedown)="mouseDown($event,node.nodeId,node.className)"
                        (mouseup)="mouseUp($event,node.nodeId,node.className)" attr.y="{{ node.nodeY }}"
                        attr.x="{{ node.nodeX }}" attr.width="{{ circleWidth }}" attr.height="{{ circleWidth }}"
                        attr.style="{{ node.style }}" attr.class="{{node.className+ ' draggable seffect'}}" rx="100"
                        (click)="symbolClick(node)" />
                    <text *ngFor="let node of endCircleNodes" attr.y="{{ node.nodeY + 60 }}"
                        attr.x="{{ node.nodeX  + 15}}" fill="#34495E" attr.font-size="{{ fontSize }}"
                        attr.class="{{node.className+'HS prevent-select'}}" attr.style="{{node.fontStyle}}">
                        {{ node.name }}
                    </text>
                    <!-- end circle end -->

                    <!-- call start -->
                    <rect *ngFor="let node of rectCallNodes" (mousedown)="mouseDown($event,node.nodeId,node.className)"
                        (mouseup)="mouseUp($event,node.nodeId,node.className)" attr.y="{{ node.nodeY }}"
                        attr.x="{{ node.nodeX }}" attr.width="{{ nodeWidth }}" attr.height="{{ nodeHeight }}"
                        attr.style="{{ node.style }}" attr.class="{{node.className+ ' draggable seffect'}}"
                        (click)="symbolClick(node)" />
                    <text *ngFor="let node of rectCallNodes" attr.y="{{ node.nodeY + 25 }}"
                        attr.x="{{ node.nodeX + 10 }}" fill="#34495E" attr.font-size="{{ fontSize }}"
                        attr.class="{{node.className+'HS prevent-select'}}" attr.style="{{node.fontStyle}}">
                        {{ node.name }}
                    </text>
                    <!-- call end-->

                    <!-- subprocess start -->
                    <rect *ngFor="let node of rectSubProcessNodes"
                        (mousedown)="mouseDown($event,node.nodeId,node.className)"
                        (mouseup)="mouseUp($event,node.nodeId,node.className)" attr.y="{{ node.nodeY }}"
                        attr.x="{{ node.nodeX }}" attr.width="{{ nodeWidth }}" attr.height="{{ nodeHeight }}"
                        attr.style="{{ node.style }}" attr.class="{{node.className+ ' draggable seffect'}}"
                        (click)="symbolClick(node)" />
                    <text *ngFor="let node of rectSubProcessNodes" attr.y="{{ node.nodeY + 25 }}"
                        attr.x="{{ node.nodeX + 10 }}" fill="#34495E" attr.font-size="{{ fontSize }}"
                        attr.class="{{node.className+'HS prevent-select'}}" attr.style="{{node.fontStyle}}">
                        {{ node.name }}
                    </text>
                    <!-- subprocess end-->

                    <!-- rectTransaction start-->
                    <rect *ngFor="let node of rectTransactionNodes"
                        (mousedown)="mouseDown($event,node.nodeId,node.className)"
                        (mouseup)="mouseUp($event,node.nodeId,node.className)" attr.y="{{ node.nodeY }}"
                        attr.x="{{ node.nodeX }}" attr.width="{{ nodeWidth }}" attr.height="{{ nodeHeight }}"
                        attr.style="{{ node.style }}" attr.class="{{node.className+ 'HS seffect'}}" rx="10"
                        (click)="symbolClick(node)" />
                    <rect *ngFor="let node of rectTransactionNodes"
                        (mousedown)="mouseDown($event,node.nodeId,node.className)"
                        (mouseup)="mouseUp($event,node.nodeId,node.className)" attr.y="{{ node.nodeY+5 }}"
                        attr.x="{{ node.nodeX+5 }}" attr.width="{{ nodeWidth-10 }}" attr.height="{{ nodeHeight-10 }}"
                        attr.style="{{ node.style }}" attr.class="{{node.className+ ' draggable seffect'}}" rx="10" />
                    <text *ngFor="let node of rectTransactionNodes" attr.y="{{ node.nodeY + 25 }}"
                        attr.x="{{ node.nodeX  + 15}}" fill="#34495E" attr.font-size="{{ fontSize }}"
                        attr.class="{{node.className+'HS prevent-select'}}" attr.style="{{node.fontStyle}}">
                        {{ node.name }}
                    </text>
                    <!-- rectTransaction end-->

                    <!-- circleMail start -->
                    <rect *ngFor="let node of circleEvents" (mousedown)="mouseDown($event,node.nodeId,node.className)"
                        (mouseup)="mouseUp($event,node.nodeId,node.className)" attr.y="{{ node.nodeY }}"
                        attr.x="{{ node.nodeX }}" attr.width="{{ circleEventWidth}}"
                        attr.height="{{ circleEventWidth }}" attr.style="{{ node.style }}"
                        attr.class="{{node.className+ ' draggable seffect'}}" rx="100" attr.fill="{{ node.bg }}"
                        (click)="symbolClick(node)" />
                    <!-- circleMail end -->

                    <!-- Free Text start -->
                    <text *ngFor="let node of freeTextNodes" attr.y="{{ node.nodeY }}" attr.x="{{ node.nodeX }}"
                        attr.font-size="{{ fontSize }}" attr.style="{{node.fontStyle}}"
                        attr.class="{{node.className+'HS draggable rotateText prevent-select seffect'}}"
                        (click)="symbolClick(node)">
                        {{ node.name }}
                    </text>
                    <!-- Free Text start -->

                    <!-- Free Text Vertical start -->
                    <text *ngFor="let node of freetextVerticalNodes" attr.y="{{ node.nodeY }}" attr.x="{{ node.nodeX }}"
                        attr.transform="rotate(270, {{ node.nodeX }}, {{ node.nodeY }})" attr.font-size="{{ fontSize }}"
                        attr.class="{{node.className+'HS draggable rotateText prevent-select'}}"
                        (click)="symbolClick(node)" attr.style="{{node.fontStyle}}">
                        {{ node.name }}
                    </text>
                    <!-- Free Text Vertical start -->

                </svg>
            </div>
        </div>
    </div>

</div>
<router-outlet></router-outlet>